class HotspotGallery extends HTMLElement {
    constructor() {
        super();
        this.currentSlideIndex = 0;
        this.isMobileView = this.isMobile(); // Store the initial state
        this.isScrolling = false; // Flag to manage ongoing scrolling
    }

    connectedCallback() {
        this.menuItems = this.querySelectorAll('.hotspot-gallery__menu-item');
        this.galleryItems = this.querySelectorAll('.hotspot-gallery__item'); // Correct item selector
        this.totalSlides = this.menuItems.length;
        this.current = this.querySelector('.hotspot-gallery__item.active');
        if (this.current.closest('.tabcontent__container') != undefined) {
            this.current.closest('.tabcontent__container').classList.add("active");
        }

        if (this.isMobile()) {
            this.initiateItemsHeight();
        }

        this.createSlideCounter(); // Create and initialize the slide counter

        this.menuItems.forEach((menuItem, index) => {
            menuItem.addEventListener('click', (e) => this.onMenuClick(e, menuItem, index));
        });

        this.updateArrowNavigation(); // Initialize arrow navigation

        // Listen for window resize event to handle height changes and recalculate itemWidth
        window.addEventListener('resize', this.onResize.bind(this));

        // Initialize the arrow state for the first load
        this.updateArrowsState();

        // Calculate initial image container heights
        this.updateImageContainerHeights();
    }

    onMenuClick(event, menuItem, index) {
        const targetGallery = menuItem.getAttribute('data-hotspot-nav-for');

        this.menuItems.forEach((item) => {
            item.classList.remove('active');
            if (item.closest('.tabcontent__container') != undefined) {
                item.closest('.tabcontent__container').classList.remove('active');
            }
        } );
        menuItem.classList.add('active');

        this.galleryItems.forEach((item) => {
            item.querySelectorAll(".hotspot-gallery__dot ").forEach((dot) => {
                dot.setAttribute('tabindex', -1);
            })
            item.classList.remove('active');
            if (item.closest('.tabcontent__container') != undefined) {
                item.closest('.tabcontent__container').classList.remove('active');
            }
        });
        const selectedGallery = this.querySelector(`[data-hotspot-gallery="${targetGallery}"]`);
        if (selectedGallery) {
            selectedGallery?.querySelector(".hotspot-gallery__dot ")?.focus();
            selectedGallery.classList.add('active');
            if (selectedGallery.closest('.tabcontent__container') != undefined) {
                selectedGallery.closest('.tabcontent__container').classList.add('active');
            }
            selectedGallery.querySelectorAll(".hotspot-gallery__dot ").forEach((dot) => {
                dot.setAttribute('tabindex', 0);
            })
        }

        this.currentSlideIndex = index;
        this.updateSlideCounter();
        this.updateArrowsState();
    }

    nextSlide() {
        if (this.currentSlideIndex < this.menuItems.length - 1) {
            this.currentSlideIndex++;
            this.menuItems[this.currentSlideIndex].click();
        }
    }

    previousSlide() {
        if (this.currentSlideIndex > 0) {
            this.currentSlideIndex--;
            this.menuItems[this.currentSlideIndex].click();
        }
    }

    updateArrowNavigation() {
        const leftArrow = document.querySelector('.left-arrow');
        const rightArrow = document.querySelector('.right-arrow');
        const menu = document.querySelector('.hotspot-gallery__menu');

        const getItemWidth = () => this.menuItems[0].offsetWidth;

        leftArrow.addEventListener('click', () => {
            if (!this.isScrolling && this.currentSlideIndex > 0) {
                this.isScrolling = true;
                menu.scrollBy({ left: -getItemWidth(), behavior: 'smooth' });
                this.previousSlide();
                this.disableArrowsTemporarily();
            }
        });

        rightArrow.addEventListener('click', () => {
            if (!this.isScrolling && this.currentSlideIndex < this.totalSlides - 1) {
                this.isScrolling = true;
                menu.scrollBy({ left: getItemWidth(), behavior: 'smooth' });
                this.nextSlide();
                this.disableArrowsTemporarily();
            }
        });
    }

    disableArrowsTemporarily() {
        const scrollDuration = 450;
        setTimeout(() => { this.isScrolling = false; }, scrollDuration);
    }

    isMobile() {
        return window.innerWidth <= 1079;
    }

    initiateItemsHeight() {
        const itemsContainer = document.querySelector('.hotspot-gallery__items');
        const initialHeight = itemsContainer.offsetHeight;
        itemsContainer.style.height = `${initialHeight}px`;
        itemsContainer.classList.add('hotspot-gallery__items--initiated');
    }

    removeHeightAndClass() {
        const itemsContainer = document.querySelector('.hotspot-gallery__items');
        itemsContainer.classList.remove('hotspot-gallery__items--initiated');
        itemsContainer.style.height = '';
    }

    createSlideCounter() {
        const counter = document.createElement('div');
        counter.classList.add('slide-counter');
        this.appendChild(counter);
        this.updateSlideCounter();
    }

    updateSlideCounter() {
        const counter = this.querySelector('.slide-counter');
        counter.textContent = `${this.currentSlideIndex + 1}/${this.totalSlides}`;
    }

    updateArrowsState() {
        const leftArrow = document.querySelector('.left-arrow');
        const rightArrow = document.querySelector('.right-arrow');

        if (this.currentSlideIndex === 0) {
            leftArrow.classList.add('disabled');
        } else {
            leftArrow.classList.remove('disabled');
        }

        if (this.currentSlideIndex === this.totalSlides - 1) {
            rightArrow.classList.add('disabled');
        } else {
            rightArrow.classList.remove('disabled');
        }
    }

    onResize() {
        const isNowMobile = this.isMobile();
        this.removeHeightAndClass();

        if (isNowMobile) {
            this.initiateItemsHeight();
        }

        this.isMobileView = isNowMobile;
        this.updateArrowNavigation();

        // Recalculate the image container heights on resize
        this.updateImageContainerHeights();
    }

    updateImageContainerHeights() {
        this.galleryItems.forEach(item => {
            const header = item.querySelector('.hotspot-gallery__header');
            const imageContainer = item.querySelector('.hotspot-gallery__image-container');

            if (this.isMobile()) {
                // Remove any inline height if on mobile view
                imageContainer.style.width = '';
                imageContainer.style.height = '';
            } else {
                const headerHeight = header ? header.offsetHeight : 0;
                const itemHeight = item.offsetHeight;
                const remainingHeight = itemHeight - headerHeight;

                imageContainer.style.width = `${remainingHeight}px`;
                imageContainer.style.height = `${remainingHeight}px`;
            }
        });
    }
}

customElements.define('hotspot-gallery', HotspotGallery);
